import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { RadioButton } from 'material-ui';
import GenericFormItem from '../GenericFormItem';

class RadiosField extends Component {
  constructor(props) {
    super();

    this.state = {
      val: props.val || _.get(props, 'form.choices[0].key'),
    };
  }

  render() {
    const {
      label,
      form,
      name,
      disabled,
      onChange,
      edit,

    } = this.props;

    const handleChange = (val) => {
      this.setState({ val }, () => onChange(name, val));
    };

    const selected = _.find(form.choices, { key: this.state.val });

    const fieldComponent = _.map(form.choices, (item, i) => (
      <RadioButton
        key={i}
        label={item.label}
        checked={item.key === this.state.val}
        onCheck={(event, val) => handleChange(val)}
        value={item.key}
        disabled={disabled}
      />
    ));

    return (
      <GenericFormItem label={label}>
        {edit ? fieldComponent : selected.label}
      </GenericFormItem>
    );
  }
}

RadiosField.propTypes = {
  val: PropTypes.string,
  form: PropTypes.objectOf(PropTypes.any),
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  edit: PropTypes.bool,
};

export default RadiosField;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/RadiosField.js